<script setup>
  defineProps({
    label: { type: String, default: null }
  })

  const { isConnected, needsOutlookReauth, handleOutlookError, startStatusPolling, stopStatusPolling } = useOutlook()
  const client = useStrapiClient()

  const hasUnreadEmails = ref(false)
  const checkInterval = ref(null)

  const tooltipContent = computed(() => {
    if (needsOutlookReauth.value) return 'Connexion Outlook expirée'
    return 'Messagerie'
  })

  watch(isConnected, connected => {
    if (!connected) hasUnreadEmails.value = false
  })

  async function checkUnreadEmails() {
    if (!isConnected.value) return
    try {
      const response = await client('outlook/unread-emails', {
        method: 'GET'
      })
      hasUnreadEmails.value = response.hasUnreadEmails
    } catch (error) {
      console.error('Failed to check for unread emails:', error)
      handleOutlookError(error, { notifyUser: false })
    }
  }

  onMounted(() => {
    startStatusPolling()
    checkUnreadEmails()
    checkInterval.value = setInterval(checkUnreadEmails, 120000)
  })

  onBeforeUnmount(() => {
    stopStatusPolling()
    if (checkInterval.value) {
      clearInterval(checkInterval.value)
    }
  })
</script>

<template>
  <Tooltip :content="tooltipContent">
    <NuxtLink
      class="flex items-center space-x-2 font-special outline-none duration-300 hover:text-viking-500 focus-visible:text-viking-500"
      to="/ats/messagerie"
    >
      <div class="relative">
        <Icon fixed-width name="envelope" size="lg" type="solid" />
        <div class="absolute -right-0.5 bottom-0 h-2 w-2 rounded-full bg-red-500" v-if="needsOutlookReauth" />
        <div class="absolute -right-0.5 bottom-0 h-2 w-2 rounded-full bg-viking-400" v-else-if="hasUnreadEmails" />
      </div>
      <div v-if="label">{{ label }}</div>
    </NuxtLink>
  </Tooltip>
</template>
